export const ADD_TO_CART: 'ADD_TO_CART' = 'ADD_TO_CART';
export const SET_CART: 'SET_CART' = 'SET_CART';
export const REMOVE_FROM_CART: 'REMOVE_FROM_CART' = 'REMOVE_FROM_CART';
export const RESET_CART: 'RESET_CART' = 'RESET_CART';
export const ADD_BUN: 'ADD_BUN' = 'ADD_BUN';